module.exports = __webpack_public_path__ + "static/media/smash_repetition_cover.f1d7385f.png";